import { LockOutlined, UserOutlined, LoginOutlined } from "@ant-design/icons";
import { Button, Form, Input, notification, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "../Auth/Login.css";
import { useState, useEffect } from "react";
import LayoutComp from "../../Components/LayoutComp";
import { UserService } from "../../Services/UserService";
import { UtilisateurService } from "../../Services/UtilisateurService"; // Importer le service UtilisateurService
import myImage from "../Image/DSS (3).png";
import myImage2 from "../Image/bg2.jpg";
import myLogo from "../Image/logo-lamps.png";

const userService = new UserService();
const utilisateurService = new UtilisateurService(); // Instancier le service UtilisateurService

const Login = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setAuth] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState(0); // Nombre de tentatives
  const [isLocked, setIsLocked] = useState(false); // Verrouillage de connexion
  const [timeLeft, setTimeLeft] = useState(60); // Temps restant en secondes
  const [isModalVisible, setIsModalVisible] = useState(false); // Contrôle la visibilité du modal
  const [userData, setUserData] = useState(null); // Stocke les données de l'utilisateur pour le renouvellement du mot de passe

  useEffect(() => {
    const storedAttempts = parseInt(localStorage.getItem("loginAttempts")) || 0;
    setAttempts(storedAttempts);

    const lockTime = localStorage.getItem("lockTime");
    if (lockTime) {
      const currentTime = new Date().getTime();
      const timeElapsed = currentTime - lockTime;

      if (timeElapsed < 60000) {
        setIsLocked(true);
        setTimeLeft(Math.floor((60000 - timeElapsed) / 1000)); // Convertir ms en secondes

        const interval = setInterval(() => {
          setTimeLeft((prev) => prev - 1);
        }, 1000);

        setTimeout(() => {
          clearInterval(interval);
          setIsLocked(false);
          setAttempts(0);
          localStorage.removeItem("loginAttempts");
          localStorage.removeItem("lockTime");
        }, 60000 - timeElapsed);
      } else {
        localStorage.removeItem("lockTime");
      }
    }
  }, []);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsLocked(false);
    }
  }, [timeLeft]);

  const onFinish = (values) => {
    if (isLocked) {
      notification.error({
        message: `Veuillez attendre encore ${timeLeft} seconde(s) avant de réessayer.`,
      });
      return;
    }

    setLoading(true);

    userService.connectUser(values).then((data) => {

      if (data.etat === false) {
        setLoading(false);
        Modal.info({
          title: "Utilisateur bloqué",
          content: "Utilisateur bloqué ! veuillez-vous rapprochez de l’administrateur.",
        });
        return;
      }

      if (data.role_name !== null) {
        if (data.pwd_status === "Expired") {
          // Gérer le mot de passe expiré
          setLoading(false);
          const key = `open${Date.now()}`; // Clé unique pour la notification

          notification.warning({
            message: "Mot de passe expiré",
            description: "Votre mot de passe a expiré. Veuillez le renouveler.",
            btn: (
              <Button
                type="primary"
                onClick={() => {
                  notification.destroy(key); // Fermer la notification
                  showModal(data); // Ouvrir le modal
                }}
              >
                Renouveler le mot de passe
              </Button>
            ),
            key, // Associe la clé unique pour pouvoir fermer la notification
            duration: 0, // Garde la notification ouverte jusqu'à ce que l'utilisateur clique sur "OK"
          });
        } else {
          // Connexion réussie
          const { username, emailaddress, profil, role_name, perim, login } = data;

          localStorage.setItem("user_connect", JSON.stringify(data));
          localStorage.setItem("auth", "true");
          setAuth(true);

          // Stocke les données supplémentaires dans le localStorage
          localStorage.setItem("login", login);
          // localStorage.setItem("password", password);
          localStorage.setItem("username", username);
          localStorage.setItem("profil", profil);
          localStorage.setItem("role_name", role_name);
          localStorage.setItem("emailaddress", emailaddress);
          localStorage.setItem("perim", perim);

          navigate("/dashboard");
        }
      } else {
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
        localStorage.setItem("loginAttempts", newAttempts);

        if (newAttempts >= 3) {
          setIsLocked(true);
          localStorage.setItem("lockTime", new Date().getTime());
          setTimeLeft(60); // Réinitialiser le chronomètre à 60 secondes
          notification.error({
            message: "Trop de tentatives échouées. Réessayez dans 1 minute.",
          });

          const interval = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
          }, 1000);

          setTimeout(() => {
            clearInterval(interval);
            setIsLocked(false);
            setAttempts(0);
            localStorage.removeItem("loginAttempts");
            localStorage.removeItem("lockTime");
          }, 60000);
        } else {
          notification.error({
            message: "Login ou Mot de passe incorrect !",
          });
        }
        setLoading(false);
      }
    }).catch((error) => {
      // Gérer les erreurs de l'API ici
      console.error(error);
      notification.error({
        message: "Erreur de connexion",
        description: "Une erreur est survenue lors de la tentative de connexion.",
      });
      setLoading(false);
    });
  };

  const showModal = (data) => {
    setUserData(data);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onPasswordFinish = (values) => {
    const payload = {
      login: userData.login,
      new_password: values.new_password,
      password_confirm: values.password_confirm,
      username: userData.username,
    };

    utilisateurService.updatePasswordConnect(payload)
      .then((response) => {
        notification.success({
          message: "Mot de passe mis à jour",
          description: "Votre mot de passe a été renouvelé avec succès. Vous pouvez maintenant vous connecter.",
        });
        setIsModalVisible(false);
        // Rediriger l'utilisateur vers la page de connexion si nécessaire
      })
      .catch((error) => {
        console.error(error);
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue lors de la mise à jour du mot de passe.",
        });
      });
  };

  if (isAuthenticated) {
    return <LayoutComp />;
  } else {
    return (
      <div className="login-page">
        <img src={myImage2} className="background-image" alt="Background" />
        <div className="content-container">
          <div className="form-container">
            <Form
              className="login-form"
              name="normal-login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              size="large"
              layout="vertical"
            >
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <img src={myLogo} style={{ width: "50%" }} alt="Logo" />
              </div>
              <h1 style={{ 
                textAlign: "center",
                fontSize: 26,
                fontWeight: 700,
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                marginBottom: 24,
              }}>
                Authentification
              </h1>
              <Form.Item
                label="Nom d'utilisateur"
                name="login"
                rules={[{ required: true, message: "Veuillez entrer votre nom d'utilisateur !" }]}
              >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
              </Form.Item>
              <Form.Item
                label="Mot de passe"
                name="password"
                rules={[{ required: true, message: "Veuillez entrer votre mot de passe !" }]}
              >
                <Input prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Password" />
              </Form.Item>

              {isLocked && (
                <div style={{ textAlign: "center", color: "white", marginBottom: "10px" }}>
                  Veuillez attendre {timeLeft} seconde(s) avant de réessayer.
                </div>
              )}

              <Form.Item>
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    loading={loading}
                    htmlType="submit"
                    disabled={isLocked}
                    style={{
                      height: 45,
                      paddingLeft: 40,
                      paddingRight: 40,
                      borderRadius: 10,
                      border: "none",
                      background: isLocked 
                        ? "#d9d9d9" 
                        : "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                      color: "#fff",
                      fontSize: 15,
                      fontWeight: 600,
                      boxShadow: isLocked ? "none" : "0 6px 15px rgba(24, 144, 255, 0.4)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!isLocked && !loading) {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 10px 20px rgba(24, 144, 255, 0.5)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isLocked && !loading) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 6px 15px rgba(24, 144, 255, 0.4)";
                      }
                    }}
                  >
                    <LoginOutlined style={{ marginRight: 8 }} />
                    Se Connecter
                  </Button>
                </span>
              </Form.Item>
              {isLocked && (
                <div style={{ textAlign: "center", color: "#ff4d4f", marginBottom: "10px", fontWeight: "bold" }}>
                  03 tentatives échouées !!!<br />
                  Réessayez dans ({timeLeft}) secondes
                </div>
              )}
            </Form>
          </div>
          <img src={myImage} className="side-image" alt="Side" />
        </div>

        {/* Modal pour renouveler le mot de passe */}
        <Modal
          title="Renouveler le mot de passe"
          visible={isModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null} // Supprimer le footer par défaut
        >
          <Form
            name="password-renew"
            onFinish={onPasswordFinish}
            layout="vertical"
          >
            <Form.Item
              label="Nouveau mot de passe"
              name="new_password"
              rules={[
                { required: true, message: "Veuillez entrer votre nouveau mot de passe !" },
                { min: 6, message: "Le mot de passe doit contenir au moins 6 caractères." },
              ]}
            >
              <Input.Password placeholder="Nouveau mot de passe" />
            </Form.Item>
            <Form.Item
              label="Confirmer le nouveau mot de passe"
              name="password_confirm"
              dependencies={['new_password']}
              rules={[
                { required: true, message: "Veuillez confirmer votre nouveau mot de passe !" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('new_password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Les mots de passe ne correspondent pas !"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirmer le nouveau mot de passe" />
            </Form.Item>
            <Form.Item>
              <span style={{ display: "flex", justifyContent: "right" }}>
                <Button type="primary" htmlType="submit" >
                  Enregistrer
                </Button>
              </span>
            </Form.Item>

          </Form>
        </Modal>
      </div>
    );
  }
};

export default Login;
